import React, { useState, useEffect } from "react";
import s from "./Proveedores.module.css";

//Servicios
import providersService from "../../../api/providers/providersService";

//assets
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import Pager from "../../Shared/Pagination/Pagination";
import ConfigsSearcher from "../../../config/Configs";
import ProviderDetail from "./Detail/ProviderDetail";
import { useTranslation } from "react-i18next";
import ModalProviders from "./ModalProviders";
import FormProviders from "./Formulario";

//Material
import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  Button,
  TableRow,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import HandshakeIcon from "@mui/icons-material/Handshake";
import useTranslationException from "../../../helpers/exceptions";
import { useNotificationContext } from "../../Notifications/CustomNotifications";

export const Proveedores = () => {
  const notification = useNotificationContext();
  const configsSearcher = ConfigsSearcher();
  const [itemDetail, setItemDetail] = useState({
    data: null,
    active: false,
  });

  // const [search, setSearch] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [manualPagination, setManualPagination] = useState(1);
  const [searching, setSearching] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [filters, setFilters] = useState({
    razonsocial: "",
    cuit: 0,
  });

  const [newFilters, setNewFilters] = useState({
    razonsocial: "",
    cuit: 0,
  });

  const [sort, setSort] = useState({
    name: "businessName",
    increasing: true,
  });

  const [edit, setEdit] = useState({
    item: null,
    index: null,
    status: false,
  });

  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  const { textColor } = useSelector((state) => state.local);
  let navigate = useNavigate();
  let location = useLocation();

  const dispatch = useDispatch();

  const newProvider = () => {
    let path = `./create`;
    navigate(path);
  };

  const handleOpen = () => setOpenModal(true);

  let fiscalIdFormat = /(\d{2})(\d{8})(\d{1})/;
  let fiscalIdSeparator = "-";
  let fiscalIdLength = 11;
  let telekinoCuit = configsSearcher.configFinder("TELEKINO_FILE_CUIT");

  const formatFiscalId = (number, regex, separator) => {
    //TODO: El que se guarda en la base esta formateado de una forma que no funciona
    let regex_ = new RegExp(/(\d{2})(\d{8})(\d{1})/);
    let matches = number.toString().match(new RegExp(regex_));
    if (matches === null) {
      return number;
    }
    let formattedNumber = matches.slice(1).join(separator);
    return formattedNumber;
  };

  const fiscalId = (fiscalId) => {
    return formatFiscalId(fiscalId, fiscalIdFormat, fiscalIdSeparator);
  };

  // const handleDelete = (item) => {
  //   setLoading(true);
  //   Swal.fire({
  //     title: `Eliminar a ${item.businessName}`,
  //     text: `Confirma que quieres eliminar a ${item.businessName} de la lista de proveedores.`,
  //     icon: 'info',
  //     showCancelButton: true,
  //     confirmButtonColor: 'primary.main',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Confirmar',
  //     cancelButtonText: 'Cancelar'
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       updateProvider({...item, enabled: false}, dispatch)
  //       .then(() => setItems(items.filter(i => i.id !== item.id)));
  //     }
  //   })
  // }

  const handleEdit = (item, index) => {
    setEdit({ item, index, status: true });
    navigate("./create");
  };

  const handleDetail = (item) => {
    setItemDetail({
      data: item,
      active: true,
    });
  };

  useEffect(() => {
    setLoading(true);
    if (searching) {
      providersService
        .searchProvider(page, perPage, newFilters, dispatch)
        .then((res) => {
          setTotalPages(res.totalPages);
          setItems(res.content);
        })
        .then(() => setLoading(false))
        .catch((e) => {
          showExpetion.showErrorModalForServiceException(
            e,
            { icon: "warning" },
            t("anErrorOccurred,TryAgain"),
            t("sorryErrorOcurred"),
          );
          setLoading(false);
        });
    } else {
      providersService
        .getProviders(page, perPage, dispatch, sort)
        .then((res) => {
          setTotalPages(res.totalPages);
          setItems(res.content);
        })
        .then(() => setLoading(false))
        .catch((e) => {
          showExpetion.showErrorModalForServiceException(
            e,
            { icon: "warning" },
            t("anErrorOccurred,TryAgain"),
            t("sorryErrorOcurred"),
          );
          setLoading(false);
        });
    }
  }, [perPage, page, searching]);

  useEffect(() => {
    providersService
      .getProviders(page, perPage, dispatch, sort)
      .then((res) => {
        setTotalPages(res.totalPages);
        setItems(res.content);
      })
      .catch((e) => {
        showExpetion.showErrorModalForServiceException(
          e,
          { icon: "warning" },
          t("anErrorOccurred,TryAgain"),
          t("sorryErrorOcurred"),
        );
        setLoading(false);
      });
  }, [sort]);

  useEffect(() => {
    if (telekinoCuit) {
      providersService
        .searchProvider(1, 1, { razonsocial: "", cuit: telekinoCuit }, dispatch)
        .then((telekinoSupplier) => {
          if (
            !(
              Array.isArray(telekinoSupplier?.content) &&
              telekinoSupplier.content[0]
            )
          ) {
            Swal.fire(
              t("providers"),
              `${t("noTelekinoSupplierRegisteredError")} ${telekinoCuit}`,
              "warning",
            );
          }
        })
        .catch((error) => {
          notification.error("Error endpoint", error.message);
        });
    }
  }, [perPage, page, searching, sort]);

  const cellStyles = {
    fontFamily: "Roboto, sans-serif",
    fontSize: "0.9rem",
    fontWeight: "400",
    borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
    cursor: "pointer",
  };

  return location.pathname.includes("create") ? (
    <FormProviders
      items={items}
      setItems={setItems}
      editable={edit}
      setEditable={setEdit}
    />
  ) : itemDetail.active ? (
    <ProviderDetail data={itemDetail.data} setData={setItemDetail} />
  ) : (
    <Grid container className={s.container}>
      <Grid item container xs={11} className={s.header}>
        <Grid item lg={4} md={5} xs={12} className={s.titleContainer}>
          <HandshakeIcon sx={{ fontSize: "1.8rem", color: "primary.main" }} />
          <h4>{t("providers")}</h4>
          <Button
            className={s.add_btn}
            variant="contained"
            color="primary"
            onClick={newProvider}
          >
            {t("add")}
          </Button>
        </Grid>

        <Grid item xs={12} md={4} lg={4} className={s.filters}>
          <Button
            variant="contained"
            className={s.filterButton}
            onClick={handleOpen}
          >
            <TuneRoundedIcon
              sx={{ color: "secondary.light", fontSize: "1.8rem" }}
            />
            <p>{t("filter")}</p>
          </Button>
          {searching && (
            <Button
              variant="contained"
              className={s.filterButton}
              onClick={() => {
                setFilters({
                  razonsocial: "",
                  cuit: 0,
                });
                setNewFilters({
                  razonsocial: "",
                  cuit: 0,
                });
                setSearching(false);
              }}
            >
              <p>{t("clearFilters")}</p>
            </Button>
          )}
        </Grid>
      </Grid>

      <Grid item container xs={11} className={s.dataContainer} sx={{ mt: 1 }}>
        {loading ? (
          <CircularProgress size={"2rem"} />
        ) : items?.length ? (
          <TableContainer className={s.tableContainer}>
            <Table className={s.table} stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontSize: "0.9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                      cursor: "pointer",
                      "&:hover": { backgroundColor: "primary.dark" },
                    }}
                    onClick={() =>
                      setSort({ name: "cuit", increasing: !sort.increasing })
                    }
                  >{`CUIT ${sort.name === "cuit" ? (sort.increasing ? "▲" : "▼") : ""}`}</TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontSize: "0.9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                      cursor: "pointer",
                      "&:hover": { backgroundColor: "primary.dark" },
                    }}
                    onClick={() =>
                      setSort({
                        name: "businessName",
                        increasing: !sort.increasing,
                      })
                    }
                  >{`${t("businessName")} ${sort.name === "businessName" ? (sort.increasing ? "▲" : "▼") : ""}`}</TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontSize: "0.9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                      cursor: "pointer",
                      "&:hover": { backgroundColor: "primary.dark" },
                    }}
                    onClick={() =>
                      setSort({ name: "phone", increasing: !sort.increasing })
                    }
                  >{`${t("phone")} ${sort.name === "phone" ? (sort.increasing ? "▲" : "▼") : ""}`}</TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontSize: "0.9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                      cursor: "pointer",
                      "&:hover": { backgroundColor: "primary.dark" },
                    }}
                    onClick={() =>
                      setSort({ name: "enabled", increasing: !sort.increasing })
                    }
                  >{`${t("state")} ${sort.name === "enabled" ? (sort.increasing ? "▲" : "▼") : ""}`}</TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor: "primary.main",
                      color: textColor,
                      fontSize: "0.9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("edit")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.map((item, i) => {
                  return (
                    <React.Fragment key={item.cuit}>
                      <TableRow
                        sx={{
                          "&:hover": { backgroundColor: "secondary.light" },
                        }}
                      >
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                          onClick={() => handleDetail(item)}
                        >
                          {fiscalId(item.cuit)}
                        </TableCell>
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                          onClick={() => handleDetail(item)}
                        >
                          {item.businessName}
                        </TableCell>
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                          onClick={() => handleDetail(item)}
                        >
                          {item.phone}
                        </TableCell>
                        <TableCell
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                          onClick={() => handleDetail(item)}
                        >
                          {item.enabled ? t("active") : t("inactive")}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            ...cellStyles,
                            backgroundColor:
                              i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                          }}
                        >
                          <EditRoundedIcon
                            sx={{ color: "primary.main" }}
                            className={s.iconbtn}
                            onClick={() => handleEdit(item, i)}
                          />
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : searching ? (
          <Grid item xs={12} className={s.noResults}>
            {t("noResults")}
          </Grid>
        ) : (
          <Grid item xs={12} className={s.noResults}>
            {t("tryInOtherMoment")}
          </Grid>
        )}
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: "50px",
        }}
      >
        <Pager
          pageSize={perPage}
          setPageSize={setPerPage}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageCustom={manualPagination}
          setPageCustom={setManualPagination}
        />
      </Grid>
      <ModalProviders
        setNewFilters={setNewFilters}
        open={openModal}
        setOpen={setOpenModal}
        setFilters={setFilters}
        filters={filters}
        setSearching={setSearching}
      />
    </Grid>
  );
};
